import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';
import * as types from './mutation-types';

export function setLearningResult({ commit }, learningResult) {
  commit(types.SET_LEARNING_RESULT, learningResult);

  return Promise.resolve(learningResult);
}

export function createAssignmentSubmission({ dispatch }, assignmentId) {
  return http.post(`${MINERVA_API_URL}/assignments/${assignmentId}/submissions`, {})
    .then((resp) => {
      dispatch('setLearningResult', resp.data);
    });
}

export function updateAssignmentSubmission({ dispatch }, params) {
  return http.patch(`${MINERVA_API_URL}/assignments/${params.card_id}/submissions`)
    .then(resp => dispatch('setLearningResult', resp.data));
}

export function setClassRanks({ commit }, { rankRatio, assignmentId }) {
  commit(types.SET_CLASS_RANKS, { rankRatio, assignmentId });

  return Promise.resolve(rankRatio);
}

export function fetchClassRanks({ dispatch }, { assignmentId, correctRate }) {
  const params = { correct_rate: correctRate };

  return http.get(`${MINERVA_API_URL}/assignments/${assignmentId}/class-ranks`, { params })
    .then((resp) => {
      dispatch('setClassRanks', { rankRatio: resp.data, assignmentId });
    })
    .catch((err) => {
      console.error('err while fetching class ranks:', err);
    });
}

export function setAllRanks({ commit }, { rankRatio, assignmentId }) {
  commit(types.SET_ALL_RANKS, { rankRatio, assignmentId });

  return Promise.resolve(rankRatio);
}

export function fetchAllRanks({ dispatch }, { assignmentId, correctRate }) {
  const params = { correct_rate: correctRate };

  return http.get(`${MINERVA_API_URL}/assignments/${assignmentId}/all-ranks`, { params })
    .then((resp) => {
      dispatch('setAllRanks', { rankRatio: resp.data, assignmentId });
    })
    .catch((err) => {
      console.error('err while fetching all ranks:', err);
    });
}

export function showForceResult({ commit }) {
  commit(types.SHOW_FORCE_RESULT);

  return Promise.resolve();
}

export function setAssignmentStats({ commit }, assignmentStats) {
  commit(types.SET_LEARNING_RESULT_STATS, assignmentStats);

  return Promise.resolve(assignmentStats);
}

export function fetchAssignmentStats({ dispatch }, classId) {
  return http.get(`${MINERVA_API_URL}/assignment-stats?class_id=${classId}`)
    .then(resp => (
      dispatch('setAssignmentStats', resp.data)
    ));
}
